"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _reactBootstrapRangeSlider = _interopRequireDefault(require("react-bootstrap-range-slider"));

var _CompletedContext = require("../CompletedContext");

require("./TaskSlider.scss");

var TaskSlider = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskSlider, _React$Component);

  var _super = (0, _createSuper2.default)(TaskSlider);

  function TaskSlider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TaskSlider);
    _this = _super.call(this, props);
    _this.state = {
      value: _this.props.start || 0
    };
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(TaskSlider, [{
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        value: e.target.value
      });
      this.props.handleChange(e.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_reactBootstrapRangeSlider.default, {
        key: this.props.key,
        value: this.state.value,
        onChange: this.handleChange,
        min: this.props.min,
        max: this.props.max,
        step: this.props.step,
        tooltip: this.props.tooltip,
        tooltipStyle: {
          width: "100px",
          color: 'red'
        }
      });
    }
  }]);
  return TaskSlider;
}(_react.default.Component); // export default class TaskSlider extends React.Component {
//   constructor(props) {
//     super(props)
//     this.state = {
//       mousedown: false,
//       nofocus: true,
//       value: 0
//     }
// 
//     this.mouseDown = this.mouseDown.bind(this)
//     this.mouseUp = this.mouseUp.bind(this)
//     this.keyDown = this.keyDown.bind(this)
//     this.touchMove = this.touchMove.bind(this)
// 
//     this.ref = React.createRef()
//   }
// 
//   componentWillMount() {
//       document.addEventListener("mousedown", this.mouseDown, false)
//       document.addEventListener("mouseup", this.mouseUp, false)
//       document.addEventListener("keydown", this.keyDown, false)
//       document.addEventListener("touchmove", this.touchMove, false)
//   }
// 
//   componentWillUnmount() {
//       document.removeEventListener("mousedown", this.mouseDown, false)
//       document.removeEventListener("mouseup", this.mouseUp, false)
//       document.removeEventListener("keydown", this.keyDown, false)
//       document.removeEventListener("touchmove", this.touchMove, false)
//   }
// 
//   mouseDown(e) {
//     this.setState({mousedown: true, nofocus: true})
//   }
// 
//   mouseUp(e) {
//     this.setState({mousedown: false})
//   }
// 
//   keyDown(e) {
//     if (e.keyCode === 9) {
//       this.setState({nofocus: false})
//     }
//   }
// 
//   touchMove(e) {
//     let element = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY)
//     if (element && element.type == "radio" && this.ref.current.contains(element)) {
//       element.click()
//     }
// 
//   }
// 
//   perc(n) {
//     return (n * 100).toFixed(2) + "%"
//   }
// 
//   render() {
//     var inputs = []
//     for (let i = 0; i < this.props.intervals; i++) {
//       inputs.push(
//         <input 
//           className={"radioslider-radio" + (this.state.nofocus ? " nofocus" : "")}
//           type="radio" 
//           name="a" 
//           key={"radioslider-radio-" + i} 
//           checked={this.state.value == i} 
//           onChange={()=>{this.setState({value: i}); this.props.onChange(i)}} 
//           style={{'--radio-width': this.perc(1 / this.props.intervals)}} 
//           aria-label={this.props.labels[i]}
//           onMouseOver={(e)=>{
//             if (this.state.mousedown) {
//               e.target.click()
//             }
//           }}
//         />
//       )
//     }
//   	return (
//       <div style={{height: '24px', margin: '1rem 15px 1rem 15px'}}>
//         <form>
//           <fieldset>
//             <div ref={this.ref} className="radioslider form-group" style={{'--progress': this.perc(this.state.value / (this.props.intervals - 1)), '--radio-width': this.perc(1 / this.props.intervals)}}>
//               <legend className="sr-only">{this.props.legend}</legend>
//               {inputs}
//             </div>
//           </fieldset>
//         </form>
//       </div>
//   	)
//   }
// 
// }


exports.default = TaskSlider;
TaskSlider.contextType = _CompletedContext.CompletedContext;